

let images = [
    '/images/screenshots/oldWork/bo2d.png',
];

export default images;